import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import "./LandingPage.css";
import "./AboutPage.css";

export default function AboutPage() {
  return (
    <div className="about-page">
      <main className="about-content">
        <Container>
          <div className="about-header">
            <h1 className="about-title">About Podium</h1>
            <p className="about-subtitle">
              Hockey league management, built by enthusiasts for enthusiasts
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">Our Story</h2>
            <p className="about-text">
              Podium is a comprehensive hockey league management platform
              designed to simplify scoring, stats tracking, roster management,
              and scheduling for leagues of all sizes.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">Credits</h2>
            <div className="about-credits">
              <div className="about-credit-card">
                <div className="about-credit-label">Original Concept & V1</div>
                <h3 className="about-credit-name">Yan Sarazin</h3>
                <a
                  href="https://builtbyageek.ca/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="about-credit-link"
                >
                  builtbyageek.ca
                  <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
                </a>
                <p className="about-credit-desc">
                  Yan created the original vision and first version of Podium,
                  establishing the foundation for what the platform has become
                  today.
                </p>
              </div>

              <div className="about-credit-card">
                <div className="about-credit-label">Current Version</div>
                <h3 className="about-credit-name">Colin McDonald</h3>
                <a
                  href="https://colinmcdonald.ca/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="about-credit-link"
                >
                  colinmcdonald.ca
                  <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
                </a>
                <p className="about-credit-desc">
                  Colin developed this version of Podium, bringing modern
                  features and enhanced functionality to serve leagues better.
                </p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">Get Started</h2>
            <p className="about-text">
              Ready to streamline your league management?{" "}
              <Link to="/register">Create a free account</Link> and set up your
              first league in minutes.
            </p>
          </div>
        </Container>
      </main>
    </div>
  );
}
